import { render, staticRenderFns } from "./Base.vue?vue&type=template&id=b9a51940&"
var script = {}


/* normalize component */
import normalizer from "!../../../../var/www/pulse/pulse_client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports